import { Experiments } from "./experiments";
export type { ExperimentConfig } from "./types/config";

export const experiments = new Experiments();
